import React, { useState } from 'react';
import { TextField } from '@cimpress/react-components';

const TextFieldExampleSimple = () => {
  const [text, setText] = useState('');

  const onInputChange = e => {
    setText(e.target.value);
  };

  return <TextField name="simple" label="Simple Text Field" value={text} onChange={e => onInputChange(e)} />;
};

export default TextFieldExampleSimple;
